import { render, staticRenderFns } from "./UserImporter.vue?vue&type=template&id=497d1399"
import script from "./UserImporter.vue?vue&type=script&lang=js"
export * from "./UserImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports